'use strict';

require('./app.js');
require('./data/chartTypes.js');
require('./data/metrics.js');
require('./enums.js');
require('./models/metric.js');
require('./models/configuration.js');
require('./collections/metrics.js');
require('./utils.js');
require('./views/selectors/source.js');
require('./views/selectors/interval.js');
require('./views/selectors/benchmark.js');
require('./views/selectors/dimensionValues.js');
require('./views/selectors/postType.js');
require('./views/selectors/layout.js');
require('./views/selectors/widget.js');
require('./views/selectors/dimension.js');
require('./views/metric.js');
require('./views/metrics.js');
require('./views/layout.js');
require('./views/forms/list.js');
require('./views/forms/chart.js');
require('./views/forms/composite.js');
require('./views/builder.js');
require('./widgets/builder.js');
require('./curations/builder.js');
require('./curations/create.js');
require('./curations/empty.js');
require('./curations/picker.js');
require('./curations/templates.js');
